import type { AreaRoute } from "./areaRoute";
import {
  GovernedOperations,
  OperationsPrincipals,
  Roles,
  type Role
} from "../../auth/roles";
import { lazyPage } from "../../lib/lazyPage";
const MyTrainingPage = lazyPage(() => import("../training/TrainingPages"), "MyTrainingPage");
const TrainingAdminPage = lazyPage(() => import("../training/TrainingPages"), "TrainingAdminPage");
const TrainingCertificatesReviewPage = lazyPage(() => import("../training/TrainingPages"), "TrainingCertificatesReviewPage");
const TrainingGapsPage = lazyPage(() => import("../training/TrainingPages"), "TrainingGapsPage");
const TrainingMatrixPage = lazyPage(() => import("../training/TrainingPages"), "TrainingMatrixPage");
const TrainingPlayerPage = lazyPage(() => import("../training/TrainingPages"), "TrainingPlayerPage");
const MyProfilePage = lazyPage(() => import("../profile/MyProfilePage"), "MyProfilePage");
const MyQuestionsPage = lazyPage(() => import("../questions/MyQuestionsPage"), "MyQuestionsPage");

export const TrainingMatrixReaders: readonly Role[] = [
  Roles.OperationsManager,
  Roles.Admin,
  Roles.PlantManager,
  Roles.Executive,
  Roles.Quality
];

export const TrainingCertificateReaders: readonly Role[] = [
  Roles.OperationsManager,
  Roles.Admin,
  Roles.Quality
];

export const StakeholderQuestionReaders: readonly Role[] = [
  Roles.OperationsManager,
  Roles.Planner,
  Roles.PlantManager,
  Roles.Admin
];

export {
  MyQuestionsPage,
  MyTrainingPage,
  MyProfilePage,
  TrainingPlayerPage,
  TrainingAdminPage,
  TrainingMatrixPage,
  TrainingGapsPage,
  TrainingCertificatesReviewPage
};

export const trainingRoutes: AreaRoute[] = [
  {
    path: "/training/:id",
    allow: OperationsPrincipals,
    element: <TrainingPlayerPage />
  },
  {
    path: "/admin/training/:id",
    allow: GovernedOperations,
    element: <TrainingAdminPage />
  },
  {
    path: "/my/profile",
    allow: OperationsPrincipals,
    element: <MyProfilePage />
  },
  {
    path: "/questions",
    allow: StakeholderQuestionReaders,
    element: <MyQuestionsPage />
  }
];